<template>
  <div class="login">
    <div class="top"></div>
    <div class="login-box">
      <van-nav-bar @click-right="goHome">
        <template #left>
          <div class="left-text">
            <div class="logo">
              <img
                class="auto-img"
                src="../assets/images/home_active.png"
                alt=""
              >
            </div>
            <div class="logo-title">Luckin Coffce</div>
          </div>
        </template>
        <template #right>
          <div class="close-box">先逛一逛</div>
        </template>
      </van-nav-bar>
      <div class="login-form">
        <div class="title">欢迎回来!</div>
        <div class="en-title">Please login to your accounts</div>

        <div class="login-form-box">
          <van-form>
            <van-field
              label="手机号"
              class="loginphone"
              placeholder="手机号"
              v-model="userLoginInfo.phone"
            />
            <van-field
              class="loginpassword"
              :type="isPassword ? 'password' : 'text'"
              label="密码"
              placeholder="密码"
              v-model="userLoginInfo.password"
              :right-icon="isPassword ? 'closed-eye' : 'eye-o'"
              @click-right-icon="viewPassword"
            />
            <div class="clearfix forgot">
              <span
                class="fr forgottext"
                @click="goFindPassword"
              >忘记密码?</span>
            </div>
            <div class="login-btn">
              <van-button
                round
                block
                native-type="submit"
                color="#0C34BA"
                @click="login"
              >登&nbsp;&nbsp;录</van-button>
            </div>
            <div class="zhuce-btn">
              <van-cell @click="showPopup">注册</van-cell>
              <van-popup
                v-model="isRegister"
                closeable
                :style="{ height: '64%' }"
                round
                position="bottom"
              >
                <div class="zhuce-popup">
                  <div class="popup-title">注册</div>
                  <van-form>
                    <van-field
                      class="loginphone register"
                      placeholder="手机号 中国(+86)"
                      v-model="uesrRegisterInfo.phone"
                    />
                    <van-field
                      class="loginphone register"
                      placeholder="昵称"
                      v-model="uesrRegisterInfo.nickName"
                    />
                    <van-field
                      class="loginpassword register"
                      placeholder="密码"
                      :type="isPassword ? 'password' : 'text'"
                      v-model="uesrRegisterInfo.password"
                      :right-icon="isPassword ? 'closed-eye' : 'eye-o'"
                      @click-right-icon="viewPassword"
                    />
                    <van-field
                      class="loginpassword register"
                      placeholder="确认密码"
                      :type="isconfirmPassword ? 'password' : 'text'"
                      v-model="uesrRegisterInfo.confirmPassword"
                      :right-icon="isconfirmPassword ? 'closed-eye' : 'eye-o'"
                      @click-right-icon="confirmPassword"
                    />
                    <div class="login-btn">
                      <van-button
                        round
                        block
                        native-type="submit"
                        color="#0C34BA"
                        @click="register"
                      >注&nbsp;&nbsp;册</van-button>
                    </div>
                  </van-form>
                </div>
              </van-popup>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/less/login.less";

import { validForm } from "../assets/js/ValidForm";
import { utils } from "../assets/js/Utils";
export default {
  data() {
    return {
      // 登录信息
      userLoginInfo: {
        phone: "",
        password: "",
      },
      // 注册信息
      uesrRegisterInfo: {
        phone: "",
        nickName: "",
        password: "",
        confirmPassword: "",
      },
      // 查看密码
      isPassword: true,
      // 查看确认密码
      isconfirmPassword: true,
      // 弹开注册框
      isRegister: false,
    };
  },
  methods: {
    // 去首页
    goHome() {
      this.$router.push({ name: "Home" });
    },

    // 忘记密码
    goFindPassword() {
      this.$router.push({ name: "Forget" });
    },

    // 查看密码
    viewPassword() {
      this.isPassword = !this.isPassword;
    },

    // 查看确认密码
    confirmPassword() {
      this.isconfirmPassword = !this.isconfirmPassword;
    },

    // 弹出注册面板
    showPopup() {
      this.isRegister = true;
    },

    // 注册
    register() {
      // 获取用户注册信息
      let userInfo = this.uesrRegisterInfo;

      // 验证注册表单
      let o = {
        phone: {
          value: userInfo.phone,
          reg: /^1[3-9]\d{9}$/,
          errorMsg: "手机格式不正确",
        },
        nickName: {
          value: userInfo.nickName,
          reg: /^[\w\u4e00-\u9fa5]{1,10}$/,
          errorMsg: "昵称格式不正确",
        },
        password: {
          value: userInfo.password,
          reg: /^[A-Za-z]\w{5,15}$/,
          errorMsg: "密码格式不正确",
        },
        confirmPassword: {
          value: userInfo.confirmPassword,
          reg: /^[A-Za-z]\w{5,15}$/,
          errorMsg: "确认密码格式不正确",
        },
      };

      if (!validForm.valid(o)) {
        // 验证不通过
        return;
      }

      if (
        this.uesrRegisterInfo.password == this.uesrRegisterInfo.confirmPassword
      ) {
        // 发起请求
        // 开启加载提示
        this.$toast.loading({
          message: "加载中...",
          // 防止穿透
          forbidClick: true,

          // 显示时间,如果时间为0，则不会自动关闭
          duration: 0,

          loadingType: "spinner",
        });
        // 序列化参数
        // 复制对象，不会更改原始对象
        let info = Object.assign({}, userInfo);
        info.appkey = this.appkey;
        let data = utils.queryString(info);
        //

        this.axios({
          method: "POST",
          //   请求参数
          url: "/register",
          data,
        })
          .then((result) => {
            // 关闭加载提示
            this.$toast.clear();

            // 如果注册成功
            if (result.data.code == 100) {
              // 关闭注册模块
              this.isRegister = false;
              // 清空注册表单的数据
              for (let key in userInfo) {
                userInfo[key] = "";
              }

              this.$notify({
                type: "warning",
                message: result.data.msg,
                background: "#F4606C",
              });
            } else {
              // 如果注册失败，则提示
              this.$notify({
                type: "warning",
                message: result.data.msg,
                background: "#F4606C",
              });
            }
          })
          .catch((err) => {
            this.$toast.clear();
          });
      } else {
        this.$notify({
          type: "warning",
          message: "两次输入的密码不一致！",
          background: "#F4606C",
        });
      }
    },

    // 登录
    login() {
      // 获取用户账号信息
      let userInfo = this.userLoginInfo;

      let o = {
        phone: {
          value: userInfo.phone,
          reg: /^1[3-9]\d{9}$/,
          errorMsg: "手机格式不正确",
        },
        password: {
          value: userInfo.password,
          reg: /^[A-Za-z]\w{5,15}$/,
          errorMsg: "密码格式不正确",
        },
      };

      // 验证表单
      if (!validForm.valid(o)) {
        // 验证不通过
        return;
      }

      // 验证通过
      // 发起请求
      // 开启加载提示
      this.$toast.loading({
        message: "加载中...",
        // 防止穿透
        forbidClick: true,
        // 显示时间,如果时间为0，则不会自动关闭
        duration: 0,
        loadingType: "spinner",
      });

      // 复制对象，不会更改原始对象
      let info = Object.assign({}, userInfo);
      info.appkey = this.appkey;
      // 序列化参数
      let data = utils.queryString(info);

      this.axios({
        method: "POST",
        //   请求参数
        url: "/login",
        // 因为参数名和变量名一样,可以简写
        data,
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 200) {
            // 在本地存储一个token
            localStorage.setItem("TK", result.data.token);
            this.$router.push({ name: "Home" });
          } else {
            // 登录失败，则提示
            this.$notify({
              type: "warning",
              message: result.data.msg,
            });
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>